import { Languages } from '@wajeez-web/core/utils';
import { useContentSelector } from '@wajeez-web/stores/content';

export const useContentEntityDetailsByIdMultilingual = () => {
  return useContentSelector(
    ({ contentEntity }) => contentEntity.detailsByIdMultilingual
  );
};

export const useContentEntityItemDetailsByIdMultilingual = () => {
  return useContentSelector(
    ({ contentEntity }) => contentEntity.itemDetailsByIdMultilingual
  );
};

export const useCreateContentEntityMultilingual = () => {
  return useContentSelector(
    ({ contentEntity }) => contentEntity.createMultilingual
  );
};

export const useEditContentEntityMultilingual = () => {
  return useContentSelector(
    ({ contentEntity }) => contentEntity.editMultilingual
  );
};

export const useSetExpectedPublishDate = (languageId: Languages) => {
  return useContentSelector(
    ({ contentEntity }) => contentEntity.setExpectedPublishDate[languageId]
  );
};

export const useGetContentEntityBadge = () => {
  return useContentSelector(
    ({ contentEntity }) => contentEntity.contentEntityBadge
  );
};

export const useSetContentEntityBadge = () => {
  return useContentSelector(
    ({ contentEntity }) => contentEntity.setContentEntityBadge
  );
};
